/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.4.0
 * @since 1.0.0
 */
import { PureComponent } from 'react';

import Icon from './Icon/Icon';
import { BlockContainerStyled, BlockTextStyled } from './styled/BlockWithIconStyled';

/**
 * @description Props for BlockWithIcon component.
 * @interface IBlockWithIconProps
 *
 * @property{string} iconLeft Path to icon positioned in left side.
 * @property{number=32} iconLeftSize Left icon size in px.
 * @property{string} iconRight Path to icon positioned in right side.
 * @property{number=32} iconRightSize Right icon size in px.
 * @property{('flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around'| 'space-evenly')='flex-start'}
 *          justifyContent Define block positioning inside the container.
 * @property{('flex-start' | 'flex-end' | 'center')='flex-start'} alignItems define vertical element positioning.
 */
export interface IBlockWithIconProps {
    alignItems?: 'center' | 'flex-start' | 'flex-end';
    className?: string;
    dataName?: string;
    iconLeft?: string | string[];
    iconLeftSize: number;
    iconRight?: string | string[];
    iconRightSize: number;
    justifyContent: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
    onClick: () => void;
}

/**
 * @description Render block with children and two optional icons.
 * @class BlockWithIcon component
 * @extends PureComponent<IBlockWithIconProps>
 */
class BlockWithIcon extends PureComponent<IBlockWithIconProps> {

    static defaultProps = {
        iconLeftSize: 32,
        iconRightSize: 32,
        justifyContent: 'flex-start',
        onClick: () => {
        },
    };

    render() {
        const {
            className,
            iconLeft,
            iconLeftSize,
            iconRight,
            iconRightSize,
            justifyContent,
            onClick,
        } = this.props;
        return (
            <BlockContainerStyled
                className={className}
                justifyContent={justifyContent}
                onClick={() => onClick()}
            >
                {
                    iconLeft &&
                    <div className="block-with-icon__icon-left">
                        <Icon
                            dataName="iconLeft"
                            icon={iconLeft}
                            size={iconLeftSize}
                        />
                    </div>
                }
                <BlockTextStyled className="block-with-icon__block-children">
                    {this.props.children}
                </BlockTextStyled>
                {
                    iconRight &&
                    <div className="block-with-icon__icon-right">
                        <Icon
                            dataName="iconRight"
                            icon={iconRight}
                            size={iconRightSize}
                        />
                    </div>
                }
            </BlockContainerStyled>
        );
    }
}

export default BlockWithIcon;
